import { EEVENT_LABEL } from 'affiny-core/analytics';
import { ESortType } from 'affiny-core/modules/api/core/resources/matchlist.resource';
export interface IFilter {
  label: string;
  isSelected?: boolean;
  sortType?: ESortType;
  trackingEvent?: EEVENT_LABEL;
}

const I18N_BASE_KEY = 'list.filter.choice.';

export const filterList = [
  {
    label: `${I18N_BASE_KEY}bestScore`,
    trackingEvent: EEVENT_LABEL.EXPLORE_FILTERS_CLICK_BEST_SCORES,
    sortType: ESortType.SCORE,
  },
  {
    label: `${I18N_BASE_KEY}lastSubscribe`,
    trackingEvent: EEVENT_LABEL.EXPLORE_FILTERS_CLICK_SUB_DATE,
    sortType: ESortType.REGISTRATION_DATE,
  },
  {
    label: `${I18N_BASE_KEY}yearsAsc`,
    trackingEvent: EEVENT_LABEL.EXPLORE_FILTERS_CLICK_ASCENDING_AGE,
    sortType: ESortType.ASC_YEARS,
  },
  {
    label: `${I18N_BASE_KEY}yearsDesc`,
    trackingEvent: EEVENT_LABEL.EXPLORE_FILTERS_CLICK_DESCENDING_AGE,
    sortType: ESortType.DESC_YEARS,
  },
];
